import axios from "axios";
import moment from "moment";
import * as cookie from "../db/cookie.js";

export default class AuthService {
  url: string;
  constructor(url: string) {
    this.url = url;
  }
  async login(email: string, password: string) {
    const expires = moment().add("7", "day").toDate();
    const data = await axios
      .post(`${this.url}/admin/login`, {
        data: JSON.stringify({ email, password }),
      })
      .then((res: any) => res)
      .catch((e: any) => e.message);
    cookie.setCookie("career-token", data.data.token, {
      expires,
      secure: true,
      sameSite: "none",
    });
    return data;
  }
}
